import { Component, OnInit, OnChanges } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { Document } from '../../models/document';
import { User } from '../../models/user';
import { Societe, Signataire } from '../../models/societe';
import { StructureSite } from '../../models/structuresite';
import { DocumentService } from '../../services/document.service';
import { Step } from '../../models/steps';

import { Store } from '@ngrx/store';
import * as fromRoot from '../../common/appstore/index';
import * as layout from '../../common/appstore/actions';
import { Form } from '../../models/form';


@Component({
  selector: 'app-cdc-steps',
  templateUrl: './cdc-steps.component.html',
  styleUrls: ['./cdc-steps.component.scss']
})
export class CdcStepsComponent implements OnInit {

  // old
  /*currentdocument: Document; //component predefini sur la version de dev

  currentsociete: Societe; //component predefini sur la version de dev
  currentsignataire: Signataire; //component predefini sur la version de dev
  currentstructuresite: StructureSite; //component predefini sur la version de dev


  nextstep: Steps;
  stepmodel: Steps;
  specificstep: Steps;

  nextsteps: Steps[] = [];

  specificstepparam: any;*/

  // old ??
  flashinfos = {
    societename: '',
    signatairename: '',
    documentype: '',
    gamme: '',
    model: ''
  }

  //new
  currentuser: User;

  type: string;
  typeDoc: string;

  //info etapes
  steps: Step; // liste de toutes les etapes
  currentSteps: Step; // l'etape affiché
  historicStep = []; // permet de revenir en arrière

  //formulaires
  currentForm: {
    "form": Array<Form>,
    "params": any
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private documentservice: DocumentService,
    private store: Store<fromRoot.AppState>
  ) {

  }

  ngOnInit() {
    this.type = this.route.snapshot.paramMap.get('type');
    this.typeDoc = this.route.snapshot.paramMap.get('typeDoc');
    this.getSteps(this.typeDoc, this.type);
    this.getCurrentState();
  }

  getCurrentState() {
    //this.getCurrentDocument();
    //this.currentdocument = this.documentservice.currentdocument;
    //this.getCurrentSociete();
    //this.getCurrentSignataire();
    this.currentuser = JSON.parse(localStorage.getItem('currentuser'));
    //this.getCurrentStructure();
  }

  protected getCurrentDocument() {
    /*this.store.select(fromRoot.getLayoutState).subscribe(state => {
      this.currentdocument = state.document;
      console.log('currentdoc from cdc steps : ' + JSON.stringify(state.document));
    });*/
    console.log(this.documentservice.currentdocument);
    return this.documentservice.currentdocument;
  }

  /*protected getCurrentSociete() {
    this.store.select(fromRoot.getLayoutState).subscribe(state => {
      this.currentsociete = state.societe;
    });
  }

  protected getCurrentSignataire() {
    this.store.select(fromRoot.getLayoutState).subscribe(state => {
      this.currentsignataire = state.signataire;
    });
  }

  protected getCurrentStructure() {
    this.store.select(fromRoot.getLayoutState).subscribe(state => {
      this.currentstructuresite = state.structuresite;
    });
  }*/

  getSteps(typeDoc, id) {
    this.documentservice.getSteps(typeDoc, id).subscribe((steps: Step) => {
      console.log(steps);
      this.steps = steps;
      this.currentSteps = steps;
    }, (err) => {
      console.warn(err);
      this.router.navigate(['choicedocument']);
    });
  }

  getForm(conf: string) {
    //conf = "solocal/gamme/loft_modules.json";
    //conf = "site/menu_nosub.json";
    //conf = "site/backoffice.json";
    //conf = "site/menu.json";
    //conf = "site/design.json";
    let obj = {
      "form": null,
      "params": null
    }
    this.documentservice.getStepForm(conf).subscribe((form: Array<Form>) => {
      console.log(form);
      obj["form"] = form;
      //this.currentForm = form;
      this.documentservice.getParamsForm(conf).subscribe((params: any) => {
        obj["params"] = params;
        this.currentForm = obj
        console.log(this.currentForm);
      }, (err) => {
        console.warn(err);
        this.currentForm = null;
      });

    }, (err) => {
      console.warn(err);
      this.currentForm = null;
    });
  }

  nextStep(steps: Step) {
    if (this.currentSteps) {
      this.historicStep.push(this.currentSteps);
    }
    this.currentSteps = steps;
  }

  backStep() {
    if (this.historicStep.length != 0) {
      this.currentSteps = this.historicStep.pop();
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/components/cdc-steps/cdc-steps.component.ts